import type { FocusSection } from "@brookbush/types";

import { useAuth } from "@clerk/nextjs";
import useSWR from "swr";

/**
 * The sections of a course the AI Tutor has recommended the signed-in learner study
 * @param {string | undefined} courseSlug - The course's slug; nothing is fetched without one
 * @returns The recommended sections, best first (empty until loaded or when there are none), and the SWR state
 */
const useRecommendedSections = (courseSlug: string | undefined) => {
	const { isSignedIn } = useAuth();

	const { data, ...rest } = useSWR<FocusSection[]>(
		isSignedIn && courseSlug && `/courses/${courseSlug}/recommended-sections`,
		{ errorRetryCount: 0 },
	);

	return { recommendedSections: data ?? [], ...rest };
};

export default useRecommendedSections;
